export const SMALL_SCREEN_BREAKPOINT = 480;
export const MOBILE_BREAKPOINT = 640;
export const TABLET_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 1024;
